import styled, { css } from "styled-components";

export const colorFromTheme = css`
    color: ${({ theme }) => theme.mode === 'dark' ? theme.dark.title : theme.light.title};
`;

export const H1 = styled.h1`
    ${colorFromTheme}
`;

export const H2 = styled.h2`
    ${colorFromTheme}
`;

export const H3 = styled.h3`
    ${colorFromTheme}
`;

export const H4 = styled.h4`
    ${colorFromTheme}
`;